<div class="flex flex-col justify-between md:px-10 xl:w-[1300px]">
  @if (transportFormService.step() === 1) {
    <app-select-transport-category />
  } @else if (transportFormService.step() === 2) {
    <div class="flex flex-col gap-10">
      <div class="mx-auto flex max-w-[500px] flex-col items-center gap-4">
        <h2 class="text-primary-900">
          {{ "prestation.transportStep2.title" | transloco }}
        </h2>
        <p class="text-paragraph-s-reg">
          {{ "prestation.transportStep2.description" | transloco }}
        </p>
      </div>
      @if (transportFormService.displayCustomEmissionFactors) {
        <app-select-custom-transport-factor />
      } @else {
        <app-select-type />
      }
      <app-select-calculation-mode />
    </div>
  } @else if (transportFormService.step() === 3) {
    <app-transport-form />
  }
</div>
<div class="mt-6 flex w-full items-end justify-between">
  <p-button
    [label]="'back' | transloco"
    (click)="back()"
    severity="secondary"
    [text]="true"
    [disabled]="transportFormService.step() === 1"
  />

  <div class="flex flex-row items-end justify-end">
    <p-button
      [label]="'close' | transloco"
      (click)="close()"
      severity="secondary"
      [text]="true"
    />
    @if (transportFormService.step() < 3) {
      <p-button
        [label]="'continue' | transloco"
        (click)="continue()"
        [disabled]="disableContinue"
      />
    }
    @if (transportFormService.step() === 3) {
      <p-button
        [label]="'save' | transloco"
        (click)="submit()"
        [loading]="loading"
        [disabled]="transportFormService.transportForm.invalid"
      />
    }
  </div>
</div>
